import { create } from 'zustand/index';

export type ITopProductsTab = 'asc' | 'desc';
export type ITopProductsView = 'sparkline' | 'table';

interface ITopProductsStore {
  view: ITopProductsView;
  tab: ITopProductsTab;
}

export const useTopProductsStore = create<ITopProductsStore>(() => ({
  view: 'sparkline',
  tab: 'desc',
}));

export const topProductsActions = {
  switchView: () => {
    const oldView = useTopProductsStore.getState().view;
    const view = oldView === 'sparkline' ? 'table' : 'sparkline';
    useTopProductsStore.setState({ view });
  },
  setTab: (tab: ITopProductsTab) => useTopProductsStore.setState({ tab }),
};
